import { render } from "./caseList.vue?vue&type=template&id=59c25a46&scoped=true"
import script from "./caseList.vue?vue&type=script&lang=js"
export * from "./caseList.vue?vue&type=script&lang=js"

import "./caseList.vue?vue&type=style&index=0&id=59c25a46&scoped=true&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c25a46"]])

export default __exports__